import { Paginator, Message, Conversation } from '@twilio/conversations';

import { MessagesCollection } from '@/lib/twilio/MessagesCollection';
import { getSortedMessages, mergePaginators } from '@/utils/conversation/messageOrganizers';
import { IConversationMessage, IMessageFetcherOptions } from '@/utils/conversation/types';

export const loadUntillFullMessagePage = async (
  messagePaginator: Paginator<Message>,
  options: IMessageFetcherOptions
) => {
  const messages = getSortedMessages(messagePaginator);

  const areOnlyRepliesLoaded = !(messages.length >= options.pageSize) && messagePaginator.hasPrevPage;

  if (areOnlyRepliesLoaded) {
    const nextPageIterator = await messagePaginator.prevPage();

    return loadUntillFullMessagePage(mergePaginators(messagePaginator, nextPageIterator), options);
  }

  return messagePaginator;
};

export const fetchConversationMessages = async (conversation: Conversation, options: IMessageFetcherOptions) => {
  const messageIterator = await conversation?.getMessages(options.pageSize);
  const messagePaginator = await loadUntillFullMessagePage(messageIterator, options);
  const messages = new MessagesCollection<IConversationMessage>({
    getParentMessageId: (message) => message.attributes?.parentMessageId,
  });

  messages.add(messagePaginator.items);

  return {
    messages,
    messagePaginator,
  };
};
